export default "<div class=\"container container-registro pb-5\">\n  <router-outlet></router-outlet>\n</div>\n";